export type Semantic = "success" | "info" | "warning" | "error" | "neutral";

const STATUS_MAP: Record<string, Semantic> = {
  ready: "success",
  done: "success",
  active: "success",
  profiling: "info",
  materializing: "info",
  running: "info",
  training: "info",
  draft: "warning",
  failed: "error",
  queued: "neutral",
  cancelled: "neutral",
  archived: "neutral",
  discarded: "neutral",
  revoked: "neutral",
};

export function getStatusSemantic(status: string): Semantic {
  return STATUS_MAP[status] ?? "neutral";
}
